import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeywordsSectionComponent } from './keywords-section.component';

import { IndianNumberPipesModule } from './../../_pipes/indian-number-pipes.module';

@NgModule({
  declarations: [KeywordsSectionComponent],
  imports: [CommonModule, IndianNumberPipesModule],
  exports: [KeywordsSectionComponent]
})
export class KeywordsSectionModule { }